import React from 'react';
import { SvgProps } from '../Login';
import './Buildings.module.scss';

export default function BoomHut(props: SvgProps) {
    return (
        <>
            <svg
                id="Layer_2"
                data-name="Layer 2"
                xmlns="http://www.w3.org/2000/svg"
                width="226"
                height="172.47"
                viewBox="0 0 226 172.47"
                styleName={`top boomhut ${props.selectedColor}`}
            >
                <defs>
                    <style>{`.cls-1{fill:#d6b2b2;}.cls-11,.cls-2{fill:#fff;}.cls-3{fill:#efcece;}.cls-4{opacity:0.1;}.cls-5{isolation:isolate;}.cls-6{fill:#3a3a3a;}.cls-7{fill:#ddc7c0;}.cls-8{fill:#1dbc61;}.cls-9{fill:#754c24;}.cls-10{fill:lime;}.cls-11{opacity:0.2;}.cls-12{opacity:0.4;}.cls-13{opacity:0.5;}.cls-14{fill:#f2f2f2;}.cls-15{fill:#ccc;}.cls-16{fill:#238e71;}.cls-17{fill:#3db371;}.cls-18{fill:none;stroke:#754c24;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.47px;}.cls-19{fill:#c7302d;}`}</style>
                </defs>
                <polygon
                    className="cls-1"
                    points="147.94 108.98 136.3 115.68 147.94 122.38 159.59 115.68 147.94 108.98"
                />
                <polygon
                    className="cls-2"
                    points="136.3 115.68 136.3 116.99 147.94 123.69 147.94 122.38 136.3 115.68"
                />
                <polygon
                    className="cls-3"
                    points="159.59 115.68 159.59 116.99 147.94 123.69 147.94 122.38 159.59 115.68"
                />
                <polygon
                    className="cls-1"
                    points="152.57 85 140.92 91.7 152.57 98.41 164.21 91.7 152.57 85"
                />
                <polygon
                    className="cls-2"
                    points="140.92 91.7 140.92 93.01 152.57 99.72 152.57 98.41 140.92 91.7"
                />
                <polygon
                    className="cls-3"
                    points="164.21 91.7 164.21 93.01 152.57 99.72 152.57 98.41 164.21 91.7"
                />
                <polygon
                    className="cls-1"
                    points="127.42 115.68 115.78 122.38 127.42 129.09 139.07 122.38 127.42 115.68"
                />
                <polygon
                    className="cls-2"
                    points="115.78 122.38 115.78 123.69 127.42 130.4 127.42 129.09 115.78 122.38"
                />
                <polygon
                    className="cls-3"
                    points="139.07 122.38 139.07 123.69 127.42 130.4 127.42 129.09 139.07 122.38"
                />
                <polygon
                    className="cls-1"
                    points="107.62 108.98 95.97 115.68 107.62 122.38 119.26 115.68 107.62 108.98"
                />
                <polygon
                    className="cls-2"
                    points="95.97 115.68 95.97 116.99 107.62 123.69 107.62 122.38 95.97 115.68"
                />
                <polygon
                    className="cls-3"
                    points="119.26 115.68 119.26 116.99 107.62 123.69 107.62 122.38 119.26 115.68"
                />
                <polygon
                    className="cls-1"
                    points="92.45 110.14 87.83 112.81 92.45 115.47 97.08 112.81 92.45 110.14"
                />
                <polygon
                    className="cls-2"
                    points="87.83 112.81 87.83 113.33 92.45 115.99 92.45 115.47 87.83 112.81"
                />
                <polygon
                    className="cls-3"
                    points="97.08 112.81 97.08 113.33 92.45 115.99 92.45 115.47 97.08 112.81"
                />
                <polygon
                    className="cls-1"
                    points="112.24 124.24 107.62 126.9 112.24 129.57 116.87 126.9 112.24 124.24"
                />
                <polygon
                    className="cls-2"
                    points="107.62 126.9 107.62 127.42 112.24 130.09 112.24 129.57 107.62 126.9"
                />
                <polygon
                    className="cls-3"
                    points="116.87 126.9 116.87 127.42 112.24 130.09 112.24 129.57 116.87 126.9"
                />
                <polygon
                    className="cls-1"
                    points="148.47 99.72 143.84 102.38 148.47 105.04 153.1 102.38 148.47 99.72"
                />
                <polygon
                    className="cls-2"
                    points="143.84 102.38 143.84 102.9 148.47 105.56 148.47 105.04 143.84 102.38"
                />
                <polygon
                    className="cls-3"
                    points="153.1 102.38 153.1 102.9 148.47 105.56 148.47 105.04 153.1 102.38"
                />
                <polygon
                    className="cls-1"
                    points="132.7 112.78 130.18 114.22 132.7 115.67 135.22 114.22 132.7 112.78"
                />
                <polygon
                    className="cls-2"
                    points="130.18 114.22 130.18 114.51 132.7 115.96 132.7 115.67 130.18 114.22"
                />
                <polygon
                    className="cls-3"
                    points="135.22 114.22 135.22 114.51 132.7 115.96 132.7 115.67 135.22 114.22"
                />
                <polygon
                    className="cls-1"
                    points="160.91 77.14 158.39 78.59 160.91 80.04 163.43 78.59 160.91 77.14"
                />
                <polygon
                    className="cls-2"
                    points="158.39 78.59 158.39 78.87 160.91 80.32 160.91 80.04 158.39 78.59"
                />
                <polygon
                    className="cls-3"
                    points="163.43 78.59 163.43 78.87 160.91 80.32 160.91 80.04 163.43 78.59"
                />
                <polygon
                    className="cls-1"
                    points="86.08 114.37 74.43 121.07 86.08 127.77 97.72 121.07 86.08 114.37"
                />
                <polygon
                    className="cls-2"
                    points="74.43 121.07 74.43 122.38 86.08 129.08 86.08 127.77 74.43 121.07"
                />
                <polygon
                    className="cls-3"
                    points="97.72 121.07 97.72 122.38 86.08 129.08 86.08 127.77 97.72 121.07"
                />
                <g className="cls-4">
                    <g className="cls-5">
                        <path d="M93.16,106.59c11.45,6.61,11.51,17.33.14,23.94s-29.89,6.61-41.33,0-11.51-17.33-.14-23.94S81.71,100,93.16,106.59Z" />
                    </g>
                </g>
                <path
                    className="cls-6"
                    d="M85.84,107.36a5,5,0,0,1-2.73-.77,5.25,5.25,0,0,1-2.2-4.59,11.72,11.72,0,0,1,6.78-10,5.8,5.8,0,0,1,5.53.16,5.23,5.23,0,0,1,2.2,4.58,11.73,11.73,0,0,1-6.78,10A7.16,7.16,0,0,1,85.84,107.36ZM90.5,93.83a4.66,4.66,0,0,0-1.86.43A9.41,9.41,0,0,0,83.31,102a2.94,2.94,0,0,0,1.12,2.58,3.46,3.46,0,0,0,3.26,0A9.41,9.41,0,0,0,93,96.79a2.92,2.92,0,0,0-1.12-2.57A2.5,2.5,0,0,0,90.5,93.83Z"
                />
                <path
                    className="cls-7"
                    d="M88.17,95.28a1,1,0,0,1-1-1V79.42a1,1,0,0,1,1.92,0v14.9A1,1,0,0,1,88.17,95.28Z"
                />
                <circle className="cls-8" cx="90.29" cy="35.97" r="21.13" />
                <circle className="cls-8" cx="80.64" cy="21.64" r="10.62" />
                <circle className="cls-8" cx="59.75" cy="12.37" r="10.62" />
                <circle className="cls-8" cx="21.14" cy="28.54" r="10.62" />
                <circle className="cls-8" cx="104.01" cy="33.38" r="10.62" />
                <circle className="cls-8" cx="27.88" cy="71.98" r="12.8" />
                <circle className="cls-8" cx="22.03" cy="63.29" r="6.44" />
                <circle className="cls-8" cx="94.32" cy="76.85" r="6.44" />
                <circle className="cls-8" cx="36.19" cy="70.41" r="6.44" />
                <circle className="cls-8" cx="47.74" cy="51.12" r="9.34" />
                <path
                    className="cls-9"
                    d="M71.25,113.45c0,2.82-3.78,5.11-8.44,5.11s-8.45-2.29-8.45-5.11c0-1.37.66-8.19,1.34-14.83.71-7,1.45-13.84,1.45-13.84H68.46S71.25,111.23,71.25,113.45Z"
                />
                <path
                    className="cls-7"
                    d="M60.55,113.59a1,1,0,0,1-.56-.18l-5.45-4a1,1,0,0,1,1.13-1.55l5.45,4a1,1,0,0,1-.57,1.74Z"
                />
                <path
                    className="cls-7"
                    d="M59.41,105.61a.87.87,0,0,1-.31,0l-3.76-1.29a1,1,0,1,1,.62-1.82l3.77,1.29a1,1,0,0,1-.32,1.87Z"
                />
                <path
                    className="cls-7"
                    d="M61.5,101.15a.92.92,0,0,1-.29,0l-5-1.59a1,1,0,0,1-.63-1.21,1,1,0,0,1,1.21-.62l5,1.59a1,1,0,0,1-.29,1.87Z"
                />
                <path
                    styleName="cls-10 medium"
                    d="M97.3,44.78,62.81,24.87,28.32,44.78h0v32l34.49,19.9h0L97.3,76.78v-32Z"
                />
                <polygon
                    className="cls-11"
                    points="28.32 44.78 28.32 76.78 62.81 96.68 62.81 64.68 28.32 44.78"
                />
                <polygon
                    className="cls-12"
                    points="62.81 24.87 28.32 44.78 62.81 64.68 97.3 44.78 62.81 24.87"
                />
                <g className="cls-13">
                    <polygon
                        className="cls-14"
                        points="47.74 76.62 47.74 69.53 39.84 64.99 39.84 72.08 47.74 76.62"
                    />
                </g>
                <polygon
                    className="cls-2"
                    points="47.74 76.62 46.83 77.14 38.94 72.6 39.84 72.08 47.74 76.62"
                />
                <polygon
                    className="cls-15"
                    points="38.94 72.6 38.94 65.51 39.84 64.99 39.84 72.08 38.94 72.6"
                />
                <g className="cls-13">
                    <polygon
                        className="cls-14"
                        points="71.25 80.24 71.25 73.15 79.15 68.61 79.15 75.7 71.25 80.24"
                    />
                </g>
                <polygon
                    className="cls-2"
                    points="71.25 80.24 72.16 80.76 80.05 76.22 79.15 75.7 71.25 80.24"
                />
                <polygon
                    className="cls-15"
                    points="80.05 76.22 80.05 69.13 79.15 68.61 79.15 75.7 80.05 76.22"
                />
                <g className="cls-13">
                    <polygon
                        className="cls-14"
                        points="84.22 73.37 84.22 66.28 92.11 61.74 92.11 68.83 84.22 73.37"
                    />
                </g>
                <polygon
                    className="cls-2"
                    points="84.22 73.37 85.12 73.89 93.02 69.35 92.11 68.83 84.22 73.37"
                />
                <polygon
                    className="cls-15"
                    points="93.02 69.35 93.02 62.26 92.11 61.74 92.11 68.83 93.02 69.35"
                />
                <path
                    className="cls-9"
                    d="M67.07,48.54c0,1.42-1.91,2.58-4.26,2.58S58.54,50,58.54,48.54,60,34.06,60,34.06h5.71S67.07,47.41,67.07,48.54Z"
                />
                <circle className="cls-8" cx="45.56" cy="30.02" r="22.46" />
                <circle className="cls-8" cx="94.32" cy="47.74" r="5.98" />
                <path
                    className="cls-16"
                    d="M60.43,61.16s-.81,2-4.57,2A5.63,5.63,0,0,1,57.42,59"
                />
                <path
                    className="cls-16"
                    d="M53.39,91.59s.57.16.84,1.17A1.56,1.56,0,0,1,53,92.61a.85.85,0,0,1-.39-.7C52.57,91.38,53.39,91.59,53.39,91.59Z"
                />
                <path
                    className="cls-16"
                    d="M53.08,96s.4.2.44,1a1.21,1.21,0,0,1-.88-.3.63.63,0,0,1-.18-.57C52.51,95.76,53.08,96,53.08,96Z"
                />
                <path
                    className="cls-16"
                    d="M54.1,88.11s.8.19,1.2,1.57a2.19,2.19,0,0,1-1.69-.15,1.21,1.21,0,0,1-.56-1C53,87.85,54.1,88.11,54.1,88.11Z"
                />
                <path
                    className="cls-16"
                    d="M55.41,78.92s1,.49,1.1,2.44a3,3,0,0,1-2.18-.73,1.59,1.59,0,0,1-.44-1.42C54,78.22,55.41,78.92,55.41,78.92Z"
                />
                <path
                    className="cls-16"
                    d="M54.6,71.31s1.18.59,1.3,2.9a3.46,3.46,0,0,1-2.58-.86,1.93,1.93,0,0,1-.53-1.69C52.92,70.49,54.6,71.31,54.6,71.31Z"
                />
                <path
                    className="cls-16"
                    d="M55.14,64.46s1.1.55,1.21,2.7a3.24,3.24,0,0,1-2.41-.8,1.81,1.81,0,0,1-.49-1.58C53.57,63.69,55.14,64.46,55.14,64.46Z"
                />
                <path
                    className="cls-16"
                    d="M52.4,98.46s-.4.2-.45,1a1.17,1.17,0,0,0,.88-.29.65.65,0,0,0,.18-.57C53,98.18,52.4,98.46,52.4,98.46Z"
                />
                <path
                    className="cls-16"
                    d="M52,90s-.8.19-1.21,1.58a2.16,2.16,0,0,0,1.69-.16,1.17,1.17,0,0,0,.56-1C53.17,89.72,52,90,52,90Z"
                />
                <path
                    className="cls-16"
                    d="M52.53,86.29s-.87.24-1.25,1.77a2.36,2.36,0,0,0,1.84-.25,1.29,1.29,0,0,0,.57-1.06C53.75,86,52.53,86.29,52.53,86.29Z"
                />
                <path
                    className="cls-16"
                    d="M53,82.25s-1,.5-1.1,2.44A2.94,2.94,0,0,0,54.1,84a1.59,1.59,0,0,0,.44-1.42C54.43,81.55,53,82.25,53,82.25Z"
                />
                <path
                    className="cls-16"
                    d="M52.52,75.29s-1.18.59-1.31,2.89a3.49,3.49,0,0,0,2.59-.86,1.89,1.89,0,0,0,.52-1.69C54.2,74.46,52.52,75.29,52.52,75.29Z"
                />
                <path
                    className="cls-17"
                    d="M60.05,59a23,23,0,0,0-4.17,3.59,10.1,10.1,0,0,0-2.6,4.6,2.27,2.27,0,0,0-.08.63c0,.21,0,.43,0,.64a12,12,0,0,0,.22,1.29c.23.93.45,1.87.65,2.82a31.38,31.38,0,0,1,.71,5.79,49.59,49.59,0,0,1-1.37,11.48,33.79,33.79,0,0,0-.77,5.66,17,17,0,0,0,.12,2.85A4.76,4.76,0,0,0,53.79,101a4.71,4.71,0,0,1-1.17-2.59,15.31,15.31,0,0,1-.24-2.87,34.65,34.65,0,0,1,.54-5.75,47.76,47.76,0,0,0,.9-11.35,30.09,30.09,0,0,0-.9-5.57c-.24-.92-.49-1.83-.76-2.75a14.13,14.13,0,0,1-.32-1.53c0-.26,0-.53,0-.8a3,3,0,0,1,.07-.79,11.6,11.6,0,0,1,2.74-5.42A24.77,24.77,0,0,1,59,57.49Z"
                />
                <path
                    className="cls-16"
                    d="M60,59.14s-5.71,3.18-9.75.79c0,0,0-.07,0-.2a4.76,4.76,0,0,1,8.47-2.2Z"
                />
                <path
                    className="cls-17"
                    d="M56,58s5,4.18,9.43,2.58a1.49,1.49,0,0,0,0-.19,4.76,4.76,0,0,0-7.91-3.74Z"
                />
                <polygon
                    className="cls-2"
                    points="82.22 30.23 89.13 39.99 83.29 39.23 83.03 44.24 75.54 35.69 82.22 30.23"
                />
                <path
                    className="cls-18"
                    d="M65.05,47.43A79.76,79.76,0,0,1,82.22,30.22"
                />
                <circle className="cls-19" cx="82.44" cy="29.92" r="1.49" />
            </svg>
        </>
    );
}
